var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.filtersContainerClass},[_c('oz-filters-desktop',{attrs:{"isResultPage":_vm.isResultPage,"glossary":_vm.glossary},on:{"filters:update":_vm.updateFilters}}),_c('oz-filters-mobile',{attrs:{"isResultPage":_vm.isResultPage,"glossary":_vm.glossary},on:{"filters:update":_vm.updateFilters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }